module.exports = __webpack_public_path__ + "img/1.dabea32d.png";